import { useQuery } from "@tanstack/react-query";

import OfferingClient from "@equidefi/portals/clients/OfferingClient";
import { useApi } from "@equidefi/portals/hooks/useApi";
import { useAuth } from "@equidefi/portals/hooks/useAuth";

export { usePlatformSettings } from "@equidefi/portals/hooks/usePlatformSettings";

/**
 * @param {string} offeringId
 * @param {import("@tanstack/react-query").QueryObserverOptions} options
 */
export const useOffering = (offeringId, options = {}) => {
  const offeringApi = useApi(OfferingClient);

  return useQuery(["offering", offeringId, "legacy"], () => offeringApi.legacyFind(offeringId), {
    enabled: !!offeringId,
    ...options,
  });
};

/**
 * @param {string | undefined} idOrSlug
 * @param {import("@tanstack/react-query").QueryObserverOptions} options
 */
export const useOfferingV2 = (idOrSlug, options = {}) => {
  const offeringApi = useApi(OfferingClient);
  const { token } = useAuth();

  // Signed-in callers get the investor fields, so a cached logged-out result must not survive login.
  return useQuery(["offering", idOrSlug, "v2", !!token], () => offeringApi.getById(idOrSlug), {
    enabled: !!idOrSlug,
    ...options,
  });
};

/**
 * @param {string} id
 * @param {import("@tanstack/react-query").QueryObserverOptions} options
 */
export const useOfferingBrokers = (id, options = {}) => {
  const offeringApi = useApi(OfferingClient);

  return useQuery(["offering", id, "brokers"], () => offeringApi.brokers(id), options);
};
